import { JSX, useContext, useMemo } from "react";
import { difference } from "lodash";
import { BenchmarkingFiltersContext } from "@app/overviews/network-benchmarking-dashboard/filters";
import { BenchmarkingCounty, BenchmarkingState } from "@app/overviews/network-benchmarking-dashboard/filters/shared";

const BenchmarkingServiceAreaFilters = (): JSX.Element => {
  const benchmarkingFiltersContext = useContext(BenchmarkingFiltersContext);

  const benchmarkingState = useMemo(() => {
    const getDifference = (state: BenchmarkingState): boolean => {
      const diff: number[] = difference(benchmarkingFiltersContext.displayedPrimaryFilters.countyIds, state.counties.map(y => y.countyId));
      return diff?.length === 0;
    }

    return benchmarkingFiltersContext.states.find(x => getDifference(x));
  }, []);

  const getCountyName = (countyId: number) => {
    const county: BenchmarkingCounty = benchmarkingState?.counties.find(x => x.countyId === countyId);
    return county?.countyName;
  }

  return (
    <div className="row mb-3">
      <div className="col-12">
        <div className="d-flex">
          <div className="service-area-filter">Service Area Filter:</div>
          <div>
            <div className="dashboard-filters-overview__filter">
              {benchmarkingState?.stateName}
            </div>
            <div>
              {benchmarkingState?.counties.length !== benchmarkingFiltersContext.displayedPrimaryFilters.countyIds.length &&
                benchmarkingFiltersContext.displayedPrimaryFilters.countyIds.map((countyId) => (
                  <span key={countyId} className="dashboard-filters-overview__filter">
                    {getCountyName(countyId)}
                  </span>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BenchmarkingServiceAreaFilters;
